module.exports = __webpack_public_path__ + "img/instagram.b9689999.png";